import { OnDeckLogo } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';

export function LogoOnlyHeader() {
  return (
    <Stack direction="horizontal">
      <OnDeckLogo width="150px" className="mb-4" />
    </Stack>
  );
}

export default LogoOnlyHeader;
